import React, { useState } from "react";
import styles from "./Button.css";
import { useRef } from "react";
import { useEffect } from "react";

export const Button = ({
  onClick,
  submit,
  icon,
  dangerous,
  secondary,
  label,
  style,
  children,
  ...props
}) => {
  const ref = useRef();

  const classNames = [
    styles.Button,
    dangerous && styles.Dangerous,
    !secondary ? styles["Button-primary"] : styles["Button-secondary"],
  ];

  return (
    <button
      style={style}
      ref={ref}
      type={!submit ? "button" : "submit"}
      className={classNames.join(" ")}
      onClick={onClick}
      {...props}
    >
      {icon && <span className={styles.Icon}>{icon}</span>}
      <span className={styles.Label}>{children}</span>
    </button>
  );
};

export default Button;
